<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card-title class="pb-5">
              <!--              <v-btn @click="$router.push({name: 'admin.campaign'})" class="btn-back">-->
              <!--                <span class="flaticon2-reply icon-lg"></span>-->
              <!--                بازگشت-->
              <!--              </v-btn>-->
              <!--              <v-spacer/>-->
              <!--              {{ $t($route.meta.title) }}-->
              <!--              <v-spacer/>-->
              <v-btn
                @click="updateCampaign"
                :loading="loading"
                class="submit-btn"
                v-status="'user_edit'"
              >
                <span class="fa fa-bookmark icon-md ml-1"></span>
                بروزرسانی
              </v-btn>
            </v-card-title>
            <v-card-text>
              <hr class="pb-3" />
              <v-row>
                <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                  <v-text-field
                    label="عنوان"
                    outlined
                    dense
                    v-model="data.name"
                    counter
                    maxlength="30"
                    @keydown="isStringKey"
                    :error-messages="errors.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg3 xl3 class="p-2">
                  <v-select
                    v-model="data.user_type"
                    :items="user_types"
                    :error-messages="errors.service"
                    item-text="name"
                    item-value="value"
                    label="هدف"
                    outlined
                    dense
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                  <v-select
                    v-model="data.target_user"
                    :items="target_users"
                    :error-messages="errors.service"
                    item-text="name"
                    item-value="value"
                    label="جدید یا قدیمی"
                    outlined
                    dense
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm12 md3 lg3 xl3>
                  <v-radio-group v-model="data.status" row>
                    <v-radio label="فعال" value="active"></v-radio>
                    <v-radio label="غیرفعال" value="inactive"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-row>

              <v-row class="justify-content-center justify-center">
                <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                  <v-btn
                    @click="patternDialog = true"
                    width="100%"
                    :loading="loading"
                    class="submit-btn"
                  >
                    <span class="fa fa-message icon-md ml-1"></span>
                    اضافه کردن پیام جدید
                  </v-btn>
                </v-flex>
              </v-row>
              <v-row class="justify-center justify-content-center">
                <v-card-title>لیست پترن های فعلی کمپین</v-card-title>
              </v-row>
              <v-row class="justify-content-center justify-center">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>شناسه پترن</th>
                        <th>زمان ارسال</th>
                      </tr>
                    </thead>
                    <tbody v-if="selectedPatterns && selectedPatterns.length">
                      <tr v-for="(item, i) in selectedPatterns" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>
                          <v-text-field
                            label="زمان به عدد"
                            dense
                            outlined
                            v-model="selectedPatterns[i].send_after"
                            append-icon="mdi-clock"
                            @keypress="isNumberKey"
                            maxlength="3"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-btn @click="calculateTime">محاسبه زمان</v-btn>
              </v-row>
            </v-card-text>
          </v-flex>

          <v-dialog v-model="patternDialog" scrollable max-width="900px">
            <v-card elevation="2" outlined :loading="loading">
              <v-card-title>انتخاب از لیست پترن های پیامک لند</v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-row class="justify-content-center justify-center">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>انتخاب</th>

                          <th>شناسه پترن</th>
                          <th>عنوان</th>
                          <th>متن</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in messages" :key="item.id">
                          <td>
                            <v-checkbox
                              @change="
                                (n) => {
                                  n
                                    ? addMessage(item.id, item.content)
                                    : removeMessage(item.id);
                                }
                              "
                            ></v-checkbox>
                          </td>
                          <td>{{ item?.id }}</td>
                          <td>{{ item?.title }}</td>
                          <td>{{ item?.content }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="calculateTimeDialog" scrollable max-width="900px">
            <v-card elevation="2" outlined :loading="loading">
              <v-card-title>محاسبه زمان ارسال پیامک ها</v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-row class="justify-content-center justify-center">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>عنوان</th>
                          <th>زمان ارسال</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in calculatedTime" :key="i">
                          <td>{{ item.caption }}</td>
                          <td>
                            <v-chip>{{ item.time | stringDate }}</v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Provinces from "@/Provinces.json";

export default {
  props: ["id"],
  name: "Edit",
  data() {
    return {
      selectedPatterns: [],
      calculatedTime: [],
      loading: false,
      calculateTimeDialog: false,
      patternDialog: false,
      messages: [],
      errors: [],
      rules: {
        isInt: [(val) => !val || Number(val.toString()) || "فقظ عدد وارد کنید"],
      },
      data: {
        name: null,
        status: null,
        user_type: null,
        target_user: null,
      },
      user_types: [
        { name: "مشتری", value: "customers" },
        { name: "کاربر", value: "users" },
        { name: "هر ۲ مورد", value: "both", disabled: true },
      ],
      target_users: [
        { name: "قدیمی", value: "old" },
        { name: "جدید", value: "new" },
        { name: "هر ۲ مورد", value: "both" },
      ],
    };
  },
  mounted() {
    this.getCampaign();
    this.provinces = Provinces;
    this.requestApiGetPayamak(
      `admin/text?search=&length=1000&column=id&dir=desc`
    ).then(({ data }) => {
      this.messages = data.data;
    });
  },
  methods: {
    calculateTime() {
      this.requestApiPost(`admin/calculateTime`, {
        patterns: JSON.stringify(this.selectedPatterns),
      }).then(({ data }) => {
        this.calculatedTime = data;
        this.calculateTimeDialog = true;
      });
    },
    addMessage(id, content) {
      if (!this.selectedPatterns) this.selectedPatterns = [];
      this.selectedPatterns.push({
        id: id,
        content: content,
        send_after: 0,
      });
    },
    removeMessage(id) {
      var indexId = this.selectedPatterns.findIndex(function (o) {
        return o.id == id;
      });
      if (indexId) {
        this.selectedPatterns.splice(indexId);
      }
    },

    getCampaign() {
      this.requestApiGet(`admin/campaign/${this.id}`).then(({ data }) => {
        this.data = { ...data.data };
        this.selectedPatterns = JSON.parse(data.data.messages);
      });
    },

    updateCampaign() {
      this.$modal.showLoading();
      this.loading = true;
      this.requestApiPut(`admin/campaign/${this.id}`, {
        patterns: JSON.stringify(this.selectedPatterns),
        ...this.data,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.$router.push({ name: "admin.campaign" });
          this.$toast.success("کمپین با موفقیت ویرایش شد.");
        })
        .catch(({ response }) => {
          this.loading = false;
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
  },
};
</script>

<style scoped></style>
